module.exports = __webpack_public_path__ + "e4045cd8a4cc91395e38708cadb63d29.svg";